<template>
  <div class="overlay center">
    <div class="modal qa">
      <p>TimeMulti: {{ $store.state.timeMulti }}x</p>
      <span>Time: {{ $store.state.time }}</span>
      <p>Day: {{ dayLength }}s</p>
      <p>Production: {{ prodLength }}s</p>

      <input
        type="number"
        min="1"
        max="1000"
        :placeholder="$store.state.timeMulti"
        @change="setNewMulti"
      />
      <div class="button" @click="$store.commit('addMoney', 9999999999999)">
        Get Money
      </div>
      <div class="button" @click="showReset = true">Restart</div>
      <div class="button" @click="$emit('finish')">Finish</div>
    </div>

    <teleport to="#app">
      <ModalReset v-if="showReset" @close="showReset = false" />
    </teleport>
  </div>
</template>

<script>
import ModalReset from "@/components/ModalReset.vue";

export default {
  name: "QA",
  emits: ["finish"],
  props: {},
  components: { ModalReset },
  data() {
    return {
      showReset: false,
    };
  },

  computed: {
    dayLength: function() {
      return (
        this.$store.state.intervalTime / this.$store.state.timeMulti / 1000
      );
    },

    prodLength: function() {
      return 1 / this.$store.state.timeMulti;
    },
  },

  mounted: function() {},

  methods: {
    setNewMulti: function(e) {
      const val = Number(e.target.value);
      this.$store.commit("setMulti", val);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.modal {
  background: $black;
  border-radius: 12px;
  padding: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  min-width: 300px;
  z-index: 999999;

  p {
    font-weight: 600;
    color: #fff;
  }

  .ghost {
    color: $black;
    color: #fff;
  }

  input {
    font-size: 24px;
    text-align: center;
    max-width: 120px;
    border-radius: 6px;
    margin-bottom: 24px;
  }

  .button {
    width: 100%;
    margin: 8px;
  }
}
</style>
